import { atom } from "recoil";
import { ITagQuery } from "../types/TagQueryTypes";

export interface RecipientAtomValue {
  tagQuery: ITagQuery | null;
  count: number | null;
  setted: "savedSearch" | "tagquery" | false;
  footerId?: string | null;
  showOnArchive?: boolean;
  searchName?: string;
  searchId?: string | null;
}

export const RecipientAtom = atom<RecipientAtomValue>({
  key: "RecipientAtom",
  default: {
    setted: false,
    tagQuery: null,
    count: null,
    footerId: null,
    searchId: null,
  },
});
